<template>
  <div id="hres83e-asset-detail" class="hres83e-asset-detail box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border collapsed">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i> 
            {{ labels['HRPM1EEC2']['0'] }}
          </h3>
        </div>
        <div class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
          	<div class="col-md-4 panel-left">
              <template v-if="detail.namimagepath !== ''">
            		<img :src="detail.namimagepath" style="width: 100%">
              </template>
              <template v-else>
                <img src="../../assets/img/no-image-landscape.png" style="width: 100%">
              </template>
              <!-- <img class="avatar" :src="detail.namimagepath"> -->
          	</div>

          	<div class="col-md-8 form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRPM1EEC2']['10'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.assetno">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRPM1EEC2']['20'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.desc_assetno">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRPM1EEC2']['40'] }}</label>
                <div class="col-sm-9">
                  <div class="form-control readonly-field-color">{{ setDateOutput(detail.dterec) }}</div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRPM1EEC2']['50'] }}</label>
                <div class="col-sm-9">
                  <textarea class="form-control textarea-text" rows="4" readonly="readonly" v-model="detail.desnote" ></textarea>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRPM1EEC2']['60'] }}</label>
                <div class="col-sm-9">
                  <textarea class="form-control textarea-text" rows="3" readonly="readonly" v-model="detail.srcasset" ></textarea>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRPM1EEC2']['70'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.desc_typasset">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRPM1EEC2']['80'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.qtybal">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRPM1EEC2']['90'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.desc_codunit">
                </div>
              </div>
          	</div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-footer">
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres83e-asset-detail',
  props: [ 'labels', 'detail', 'labelsButton', 'toggle', 'data', 'nowLang' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// assetDetail.vue?30fb0ebb